function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Xl/Portal-Asociado-Menu",
  transform: "translate(-290.000000, -494.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(290.000000, 494.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bounds",
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,15.1313322 L9,25.5691571 C9,26.3589909 9.613125,27 10.3696875,27 L22.6303125,27 C23.386875,27 24,26.3589909 24,25.5691571 L24,2.9191059 C24,2.12927213 23.386875,1.4872 22.6303125,1.4872 L10.3696875,1.4872 C9.613125,1.4872 9,2.12927213 9,2.9191059 L9,6.85370229 M21,13.5 C21,15.4334212 19.4336794,17 17.5005767,17 C15.567474,17 14,15.4334212 14,13.5 C14,11.5665788 15.567474,10 17.5005767,10 C19.4336794,10 21,11.5665788 21,13.5 Z M16.5,25.25 C16.5,25.3881015 16.38812,25.5 16.2500412,25.5 C16.1119624,25.5 16,25.3881015 16,25.25 C16,25.1118985 16.1119624,25 16.2500412,25 C16.38812,25 16.5,25.1118985 16.5,25.25 Z M11,23 C11,19.6860841 13.9108315,17 17.5005843,17 C21.0903371,17 24,19.6860841 24,23 M6.86142122,11.8538965 L6.86142122,8.69562449 M5.28249781,10.2748668 L8.43970681,10.2748668 M15.4998,3.3 L17.4139239,3.3 M16,25.25 L16.456862,25.25 M9.5,23.5 L23.5,23.5 M23.5,4.86784498 L9.5,4.86784498 M7.6451957,13.9072517 L10.1018657,16.0641463 L10.1018657,13.9072517 C11.4232162,13.9072517 12.4947538,12.8357141 12.4947538,11.5143637 L12.4947538,9.26179604 C12.4947538,7.93938258 11.4232162,6.86784498 10.1018657,6.86784498 L8.40313847,6.86784498 L3.89375107,6.86784498 C2.5713376,6.86784498 1.4998,7.93938258 1.4998,9.26179604 L1.4998,11.5143637 C1.4998,12.8357141 2.5713376,13.9072517 3.89375107,13.9072517 L7.6451957,13.9072517 Z",
  id: "Stroke-17",
  stroke: "#EB5F0A",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

function SvgIconCamdoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D6E3918F-D03E-4281-A0F5-1E438B415E63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamdoctor);
export default __webpack_public_path__ + "static/media/icon_camdoctor.2399d6e6.svg";
export { ForwardRef as ReactComponent };